module.exports = __webpack_public_path__ + "img/mb_btn.7532037e.png";